<script>
import Hammer from "hammerjs";

const drawerWidth = 300;

export default {
  name: "Drawer",
  data() {
    return {
      delta: 0,
      moving: false,
    };
  },
  mounted() {
    this.hammer = new Hammer(this.$refs.drawer);
    this.hammer.on("pan", (ev) => {
      if (
        (ev.direction === Hammer.DIRECTION_LEFT ||
          ev.direction === Hammer.DIRECTION_RIGHT) &&
        ev.deltaX <= 0
      ) {
        this.moving = true;
        this.delta = ev.deltaX;
      }
    });
    this.hammer.on("panend", (ev) => {
      this.moving = false;
      this.delta = 0;
      if (ev.additionalEvent === "panleft" && ev.deltaX < -20) {
        this.$store.commit("setMenuOpen", false);
      }
    });
  },
  beforeDestroy() {
    this.hammer.destroy();
  },
  computed: {
    offset() {
      return this.$store.state.menuOpen ? this.delta : -1 * drawerWidth;
    },
    ratio() {
      return (this.offset + drawerWidth) / drawerWidth;
    },
    drawerStyle() {
      return {
        width: drawerWidth + "px",
        transition: this.moving ? "none" : undefined,
        transform: `translate3d(${this.offset}px, 0, 0)`,
        boxShadow: this.$store.state.menuOpen
          ? `0 4px 10px rgba(205, 221, 233, 0.5), 0 0 0 1000px rgba(0, 0, 0, ${
              this.ratio / 8
            })`
          : undefined,
      };
    },
  },
};
</script>
<template>
  <div class="drawer-container">
    <div
      v-show="$store.state.menuOpen"
      class="drawer-background"
      @click="$store.commit('setMenuOpen', false)"
    ></div>
    <div class="drawer" ref="drawer" :style="drawerStyle">
      <slot />
    </div>
  </div>
</template>
<style lang="scss">
.drawer-container {
  z-index: 10;

  .drawer-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }

  .drawer {
    z-index: 1;
    position: fixed;
    background-color: var(--background-color);
    width: 250px;
    height: 100vh;

    transition: transform 0.2s, box-shadow 0.2s;

    overflow-y: scroll;
    overflow-x: hidden;
  }
}
</style>
